import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';
import placeholderImgUrl from '@assets/image/img_default.svg';

// 전역적으로 사용하기 위해서. (삭제되도 유지하게)
let observer = null;

const LOAD_IMG_EVENT_TYPE = 'loadImage';

const onIntersection = (entries, io) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      io.unobserve(entry.target);
      entry.target.dispatchEvent(new CustomEvent(LOAD_IMG_EVENT_TYPE));
    }
  });
};

const Image = ({
  lazy,
  threshold = 0.5,
  src,
  block,
  width,
  height,
  alt,
  mode,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);
  const imageStyle = {
    width,
    height,
    objectFit: mode, // cover, fill, contain
    display: block ? 'block' : undefined,
  };

  const handleImgError = (e) => {
    e.target.src = placeholderImgUrl;
  };

  useEffect(() => {
    if (!lazy) {
      setLoaded(true);
      return;
    }
    const handleLoadImage = () => setLoaded(true);

    const imgElement = imgRef.current;

    imgElement?.addEventListener(LOAD_IMG_EVENT_TYPE, handleLoadImage);

    return () => {
      imgElement?.removeEventListener(LOAD_IMG_EVENT_TYPE, handleLoadImage);
    };
  }, [lazy]);

  useEffect(() => {
    if (!lazy) return;
    observer = new IntersectionObserver(onIntersection, { threshold });
    imgRef.current && observer.observe(imgRef.current);
  }, [lazy, threshold]);

  return (
    <img
      {...props}
      ref={imgRef}
      alt={alt}
      src={loaded ? src : placeholderImgUrl}
      style={{ ...props.style, ...imageStyle }}
      onError={handleImgError}
    />
  );
};

Image.propTypes = {
  lazy: PropTypes.bool,
  threshold: PropTypes.number,
  src: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alt: PropTypes.string,
  mode: PropTypes.string,
};

export default Image;
